import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-send-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round">
      <path
        d="M8.933 8.21344L14.593 6.32677C17.133 5.4801 18.513 6.86677 17.673 9.40677L15.786 15.0668C14.52 18.8734 12.44 18.8734 11.173 15.0668L10.613 13.3868L8.933 12.8268C5.126 11.5601 5.126 9.48677 8.933 8.21344Z" />
      <path d="M10.74 13.1004L13.127 10.707" />
    </svg>
  `,
})
export class SendIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');
}
